export default "__VITE_ASSET__09212f6e__"